// ----------------------------------------------------------------------

const breakpoints = {
  values: {
    xs: 0,
    sm: 700,
    md: 900,
    // md: 1200,
    lg: 1388,
  },
};

export default breakpoints;
